import { useEffect, useState } from "react";
import axios from "axios";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "context/UserContext";
import { Flex, Text, Box, Image, VStack, Button } from "@chakra-ui/react";

import logo from "../../assets/logo.png";
import FormikInput from "components/formikInput";
import FormikTextArea from "components/formikTextArea";
import kidsImage from "../../assets/register-image-kids.png";

const RegisterPage = () => {
  const navigate = useNavigate();
  const { signIn } = useUserContext();
  const [isRegisterDisabled, setIsRegisterDisabled] = useState(true);

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      cnfmPassword: "",
      address: "",
      city: "",
      postCode: "",
      rejected: "Donate to charity",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("First name cannot be empty"),
      lastName: Yup.string().required("Last name cannot be empty"),
      phone: Yup.string().required("Phone Number cannot be empty"),
      email: Yup.string()
        .email("Invalid Email")
        .required("Email cannot be empty"),
      password: Yup.string().required("Password cannot be empty"),
      cnfmPassword: Yup.string().required("Confirm Password cannot be empty"),
      address: Yup.string().required("Address cannot be empty"),
      city: Yup.string().required("City cannot be empty"),
      postCode: Yup.string().required("Post Code cannot be empty"),
      rejected: Yup.string().required("Please select an option"),
    }),
    onSubmit: (values) => handleRegister(values),
  });

  useEffect(() => {
    if (
      !(
        formik.values["firstName"] &&
        formik.values["lastName"] &&
        formik.values["email"] &&
        formik.values["phone"] &&
        formik.values["postCode"] &&
        formik.values["city"] &&
        formik.values["address"] &&
        formik.values["password"] &&
        formik.values["cnfmPassword"]
      )
    ) {
      setIsRegisterDisabled(true);
      return;
    }

    if (formik.values["password"] !== formik.values["cnfmPassword"]) {
      setIsRegisterDisabled(true);
      return;
    }

    setIsRegisterDisabled(false);
  }, [formik.values]);

  const handleSkip = () => {
    navigate("/login");
  };

  const handleRegister = async (values) => {
    try {
      const data = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.email,
        password: values.password,
        title: "",
        address: values.address,
        city: values.city,
        postcode: values.postCode,
        contact_number: values.phone,
        bank_name: "",
        account_number: "",
        sort_code: "",
        rejected_item_action: values.rejected,
      };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/register`,
        data
      );
      if (response.status === 200) {
        console.log(response.data);
        signIn(response.data);
        navigate("/dashboard");
      }
      console.log("yep");
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Flex
      justify="center"
      align="center"
      height="100vh"
      bg="white"
      border="1px solid #2a4567"
      position="relative"
      boxShadow="0px 4px 20px rgba(0, 0, 0, 0.25)"
    >
      {/* Left Content */}
      <Box
        flex={1}
        justifyContent="center"
        alignItems="center"
        display={"flex"}
      >
        <VStack align="flex-center" spacing={4} width={425}>
          <Image src={logo} width={"425px"} height={"100px"} />
          <Text
            fontFamily={"PlusJakartaSansMedium"}
            fontSize={"36px"}
            lineHeight={"38px"}
            color={"#000000"}
            textAlign={"center"}
          >
            Register our community
          </Text>
          <Text
            fontFamily={"PlusJakartaSansRegular"}
            fontSize={"16px"}
            lineHeight={"28px"}
            textAlign={"center"}
            color={"#898989"}
          >
            Start your journey with KWC
          </Text>
          <VStack align="flex-center" spacing={4}>
            <Flex flexDirection={"row"} gap={4}>
              <FormikInput
                name="firstName"
                type="text"
                label="First Name"
                placeholder={"Enter Your First Name"}
                formik={formik}
              />

              <FormikInput
                name="lastName"
                type="text"
                label="Last Name"
                placeholder={"Enter Your Last Name"}
                formik={formik}
              />
            </Flex>
            <FormikInput
              name="email"
              type="text"
              label={"Email Address"}
              placeholder={"Enter Your Email Address"}
              formik={formik}
            />
            <FormikInput
              name="phone"
              type="text"
              label={"Phone Number"}
              placeholder={"Enter Your Phone Number"}
              formik={formik}
            />
            <FormikTextArea
              name={"address"}
              label={"Address"}
              placeholder={"Enter your address"}
              formik={formik}
            />
            <Button
              bgColor={"#456EFF"}
              colorScheme="#456EFF"
              borderRadius={"12px"}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textAlign={"center"}
              w={"100%"}
              h={"48px"}
              marginTop={3}
              onClick={() => formik.handleSubmit()}
              isDisabled={isRegisterDisabled}
            >
              Continue
            </Button>
          </VStack>
          <Flex justifyContent={"center"} alignItems={"center"} gap={1}>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#000000"}
            >
              Already have an account?
            </Text>
            <Text
              fontFamily={"PlusJakartaSansRegular"}
              fontSize={"12px"}
              lineHeight={"18px"}
              color={"#456EFF"}
              cursor={"pointer"}
              textDecoration={"underline"}
              onClick={() => navigate("/login")}
            >
              Sign In
            </Text>
          </Flex>
        </VStack>
      </Box>
      {/* Right Image */}
      <Box flex={1}>
        <Image
          src={kidsImage}
          alt="Kids Fashion"
          objectFit="cover"
          width={589}
          height={440}
        />
      </Box>
    </Flex>
  );
};

export default RegisterPage;
